import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const UserMenu: React.FC = () => {
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Logic để đóng dropdown khi click ra ngoài
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (!user) {
    return null; // Không hiển thị gì nếu người dùng chưa đăng nhập
  }

  return (
    <div className="user-menu" ref={menuRef}>
      <button className="avatar-button" onClick={() => setIsOpen(!isOpen)}>
        <img src={user.picture} alt={user.name} className="user-avatar" />
      </button>

      {isOpen && (
        <div className="dropdown-menu">
          <div className="dropdown-header">
            Signed in as <br />
            <strong>{user.name}</strong>
          </div>
          <Link to="/studio" className="dropdown-item desktop-only" onClick={() => setIsOpen(false)}>
            Content Management
          </Link>
          <button onClick={logout} className="dropdown-item dropdown-item-logout">
            Log out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;